module.exports = __webpack_public_path__ + "static/media/b13.e332c537.webp";